import { useApi } from 'soykajs/composables/api'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLockStore = defineStore('lock', () => {
  const lockKeys = ref({})
  const { refresh: unlock } = useApi({
    url: 'lock_reset',
  })

  async function resetAll() {
    const p = []
    const lk = { ...lockKeys.value }
    for (const [k, v] of Object.entries(lk)) {
      const [entity_name, id] = k.split('/')
      p.push(unlock({ query: { entity_name, id }, headers: { 'X-Api-Lock': v } }))
    }
    await Promise.all(p)
    lockKeys.value = {}
  }

  return {
    lockKeys,
    resetAll,
  }
})
